import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiResponse } from 'src/app/models/apiResponse.model';
import { ApiFilter, DefaultFilter, FieldsSelection, GroupByConfig } from 'src/app/models/apiParams.model';
import { announcement } from 'src/app/models/communication.model';
import { addClientToAnnouncement } from 'src/app/models/request.model';
import { BaseApiService } from '../base/base-api.service';

/**
 * Communication Service - Handles announcements and client communications
 */
@Injectable({ providedIn: 'root' })
export class CommunicationService extends BaseApiService {
    private readonly announcementPath = '/communication/v1/announcement/';

    constructor(http: HttpClient) {
        super(http);
    }

    /*-------------------------
    == ANNOUNCEMENT CALLS ==
    -------------------------*/

    getAnnouncements(limit?: number, page?: number, orderBy?: string | null, filter?: string | ApiFilter | null, fields?: FieldsSelection | null, defaultFilter?: DefaultFilter | null, groupBy?: GroupByConfig | null): Observable<apiResponse> {
        return this.getAll<apiResponse>(this.announcementPath, {
            limit, page, orderBy: orderBy || undefined, filter: filter || undefined, fields: fields || undefined, defaultFilter: defaultFilter || undefined, groupBy: groupBy || undefined
        });
    }

    getAnnouncementID(id: number): Observable<apiResponse> {
        return this.getById<apiResponse>(this.announcementPath, id);
    }

    addAnnouncement(data: announcement): Observable<apiResponse> {
        return this.post<apiResponse>(this.announcementPath, data, 'json');
    }

    addClientToAnnouncement(data: addClientToAnnouncement, announcementID: number): Observable<apiResponse> {
        return this.post<apiResponse>(`${this.announcementPath}${announcementID}/client`, data, 'json');
    }

    updateAnnouncement(data: announcement, id: number): Observable<apiResponse> {
        return this.put<apiResponse>(this.announcementPath, id, data, 'json');
    }

    deleteAnnouncement(id: number): Observable<apiResponse> {
        return this.delete<apiResponse>(this.announcementPath, id);
    }

    deleteClientFromAnnouncement(announcementID: number, announcementclientID: number): Observable<apiResponse> {
        return this.delete<apiResponse>(`${this.announcementPath}${announcementID}/client/`, announcementclientID);
    }
}
